window.initaliseFormCTAs = function() {

  function hasClass(elem, className) {
      return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
  }

  function addClass(elem, className) {
      if (!hasClass(elem, className)) {
          elem.className += ' ' + className;
      }
  }

  function removeClass(elem, className) {
      var newClass = ' ' + elem.className.replace( /[\t\r\n]/g, ' ') + ' ';
      if (hasClass(elem, className)) {
          while (newClass.indexOf(' ' + className + ' ') >= 0 ) {
              newClass = newClass.replace(' ' + className + ' ', ' ');
          }
          elem.className = newClass.replace(/^\s+|\s+$/g, '');
      }
  } 

  function isValidEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
  };

  const formCTAs = document.getElementsByClassName("form-cta__button");

  for (let i = 0; i < formCTAs.length; i++) {
    const button = formCTAs[i];
    const id = formCTAs[i].dataset.id;
    const link = formCTAs[i].dataset.href;
    const param = formCTAs[i].dataset.param;

    if (id){
        const input = document.getElementById('input'+id);
        const label = document.getElementById('label'+id);
        let validateEmail = false;
        if (input.dataset.validateAsEmail &&
            input.dataset.validateAsEmail.toLowerCase() === 'true') {
            validateEmail = true;
            addClass(button, 'form-cta__button--disabled');
        }

        let expEditor = false;
        if (input.dataset.expEditor &&
            input.dataset.expEditor.toLowerCase() === 'true') {
            expEditor = true;
            addClass(label, "form-cta__label--editing"); 
        }

        button.addEventListener("click", function(e) {
            if (validateEmail && (!input.value || !isValidEmail(input.value))) {
               e.preventDefault();            
            }
        });

        input.addEventListener("input", function(e) {
            if (e.target.value) {
                button.setAttribute("href", link + "?" + param + "=" + e.target.value);
                removeClass(button, 'form-cta__button--disabled');
            } else {
                button.setAttribute("href", link);
            }
            if(validateEmail && !isValidEmail(e.target.value)) {
                addClass(button, 'form-cta__button--disabled');
            }
        });

        input.addEventListener("focus", function(e) {
            if (!expEditor)
                addClass(label, "form-cta__label--has-value");           
        });

        input.addEventListener("blur", function(e) {
            if (!e.target.value)
                removeClass(label, "form-cta__label--has-value");           
        });  
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  window.initaliseFormCTAs();
});
